import type { LogFn } from '../log.js';
import { SessionWorktreeManager, defaultWorktreesRootPath } from '../worktrees/manager.js';
import { PreviewWorktreeManager } from '../worktrees/manager/preview-worktree-manager.js';

export function createBridgeWorktreeManagers(options: {
  worktreesRootPath?: string;
  log: LogFn;
}): {
  worktreesRootPath: string;
  sessionWorktreeManager: SessionWorktreeManager;
  previewWorktreeManager: PreviewWorktreeManager;
} {
  const worktreesRootPath = options.worktreesRootPath ?? defaultWorktreesRootPath();
  return {
    worktreesRootPath,
    sessionWorktreeManager: new SessionWorktreeManager({ worktreesRootPath, log: options.log }),
    previewWorktreeManager: new PreviewWorktreeManager({ worktreesRootPath, log: options.log }),
  };
}
